function getStaticClassNames(_ref) {
  let {
    themeName,
    classNamesPrefix,
    selector,
    withStaticClass
  } = _ref;

  if (withStaticClass === false) {
    return [];
  }

  return themeName.map(n => `${classNamesPrefix}-${n}-${selector}`);
}

export { getStaticClassNames };